export default __webpack_public_path__ + "static/media/img-hero-frame.9e384889.png";